import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    padding: ", ";\n    border-radius: ", ";\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    appearance: none;\n    border: 0 none;\n\n    transition: background-color ", "s ease-in;\n    background-color: transparent;\n\n    ", ";\n    ", ";\n    ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        &:hover {\n            background-color: ", ";\n        }\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { marginAttributes } from '../../system/attributes';
import { makePropList, getPropsBlocker } from '../../utils';
import { getComponentOverride } from '../../system/mixins/getComponentOverride';
import { color, spacing, borderRadius } from '../../system/mixins';
import { transitionDurationInSec } from '../../constants';
var propertyList = makePropList(['light']);

var getRootDynamicStyle = function getRootDynamicStyle(_ref) {
  var light = _ref.light;
  var result = css(_templateObject(), color(light ? 'neutral.02' : 'primary.lightest'));
  return result;
};

export var IconButtonRoot = styled.button.withConfig(getPropsBlocker(propertyList))(_templateObject2(), spacing(1), borderRadius('soft'), transitionDurationInSec, getRootDynamicStyle, getComponentOverride('IconButton'), marginAttributes);